import ta from './ta'
import admin from './admin'

let r = [];
admin.forEach(i => {
  r.push(i)
})

ta.forEach(i => {
  r.push(i)
})

export default r